import { Component, OnInit, inject, viewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { CreateShortLinkCommand, UrlType } from 'src/app/core/api/models';
import { ShortLinksService, ZonesService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { AppStateService } from 'src/app/core/services/app-state.service';
import { ConsoleService } from 'src/app/core/services/console.service';
import { ZonesSelectSearchComponent } from 'src/app/shared/components/select-search/zones-select-search.component';
import { SmartSendMapControlComponent } from 'src/app/shared/components/smart-send-map-control/smart-send-map-control.component';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { ShortLinksMapControlModule } from './short-links-map-control/short-links-map-control.module';


@Component({
    selector: 'app-short-links-form',
    templateUrl: './short-links-form.component.html',
    imports: [BaseFormModule, ShortLinksMapControlModule]
})
export class ShortLinksFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  appStateService = inject(AppStateService);
  protected currentService = inject(ShortLinksService);
  //#region Properties
  model: CreateShortLinkCommand = {};
  get UrlType() {
    return UrlType;
  }
  readonly Map = viewChild<SmartSendMapControlComponent>('Map');
  readonly citySelectSearch = viewChild<ZonesSelectSearchComponent>('citySelectSearch');

  stateId: number = null;
  cityId: number = -1;
  isShowIdOrUrlSelector: boolean = false;
  linkFieldType: 'socialMediaId' | 'mainUrl' | 'map' = 'socialMediaId';
  socialMediaId: string = '';

  //#endregion

  constructor(
    public zoneService: ZonesService
  ) {
    super();
  }

  ngOnInit() {
    this.getVocabs();
    this.initForm();
    this.onChangeLinkFieldType();
  }

  initForm() {
    this.form = new FormGroup({
      title: new FormControl(''),
      linkType: new FormControl(''),
      urlType: new FormControl('', Validators.required),
      socialMediaId: new FormControl(''),
      mainUrl: new FormControl(''),
      stateControl: new FormControl(''),
      cityControl: new FormControl(''),
    });
  }

  //#region Api

  //Create
  baseCreateApi(model: CreateShortLinkCommand) {
    this.loading = true;

    this.currentService
      .shortLinksCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  changeValidation(urlType: UrlType) {
    if (
      urlType == UrlType.MapIrLink ||
      urlType == UrlType.NeshanLink ||
      urlType == UrlType.WazeLink ||
      urlType == UrlType.GoogleLink
    ) {
      this.form.get('mainUrl').clearValidators();
      this.form.get('socialMediaId').clearValidators();
    }
  }

  isShowMap(): boolean {
    return (
      this.model.urlType == UrlType.MapIrLink ||
      this.model.urlType == UrlType.NeshanLink ||
      this.model.urlType == UrlType.WazeLink ||
      this.model.urlType == UrlType.GoogleLink
    );
  }

  onChangeUrlType(urlType: UrlType) {
    this.changeValidation(urlType);

    if (
      [
        UrlType.GoogleLink,
        UrlType.NeshanLink,
        UrlType.WazeLink,
        UrlType.MapIrLink,
      ].includes(urlType)
    ) {
      this.isShowIdOrUrlSelector = false;
      this.linkFieldType = 'map';
      return;
    }

    if (
      [
        UrlType.Instagram,
        UrlType.Telegram,
        UrlType.Facebook,
        UrlType.LinkedIn,
        UrlType.Twitter,
        UrlType.YouTube,
      ].includes(urlType)
    )
      this.isShowIdOrUrlSelector = true;
    else this.isShowIdOrUrlSelector = false;

    this.linkFieldType = 'mainUrl';
    this.model.mainUrl = '';
    this.onChangeLinkFieldType();
  }

  //url or id
  onChangeLinkFieldType() {
    this.form.get('mainUrl').clearValidators();
    this.form.get('socialMediaId').clearValidators();

    if (this.linkFieldType == 'socialMediaId')
      this.form.get('socialMediaId').setValidators([Validators.required]);
    else if (this.linkFieldType == 'mainUrl')
      this.form
        .get('mainUrl')
        .setValidators([Validators.required, Validators.maxLength(1000)]);

    this.form.get('mainUrl').updateValueAndValidity();
    this.form.get('socialMediaId').updateValueAndValidity();
    this.model.mainUrl = '';
  }

  onAttachIdToUrl() {
    if (this.linkFieldType == 'mainUrl') return;

    let mainDomain: string = '';

    switch (this.model.urlType) {
      case UrlType.Instagram:
        mainDomain = 'https://www.instagram.com/';
        break;
      case UrlType.Telegram:
        mainDomain = 'https://t.me/';
        break;
      case UrlType.LinkedIn:
        mainDomain = 'https://linkedin.com/in/';
        break;
      case UrlType.Twitter:
        mainDomain = 'https://twitter.com/';
        break;
      case UrlType.Facebook:
        mainDomain = 'https://www.facebook.com/';
        break;
      case UrlType.YouTube:
        mainDomain = 'https://www.youtube.com/';
        break;
    }

    this.model.mainUrl = mainDomain + this.socialMediaId;
  }

  onCityChange($event) {
    if (this.citySelectSearch() == null) return;
    this.cityId = $event;
    this.zoneService
      .zonesGetZoneCoordinates({ ZoneId: this.cityId })
      .subscribe((result) => {
        try {
          let center = JSON.parse(result.data) as mapboxgl.LngLatLike;
          var tmp = center[0];
          center[0] = center[1];
          center[1] = tmp;
          this.Map().SetCenter(center);
        } catch (error) {
          this.loggerService.logError(
            this.tagName,
            error,
            EventTypes.contentManagement
          );
        }
      });
  }

  onMapSaveButtonClicked(lngLat: mapboxgl.LngLat) {
    switch (this.model.urlType) {
      case UrlType.GoogleLink:
        this.model.mainUrl = `https://www.google.com/maps/@${lngLat.lat},${lngLat.lng}z`;
        break;
      case UrlType.MapIrLink:
        this.model.mainUrl = `https://map.ir/lat/${lngLat.lat}/lng/${lngLat.lng}/z/7`;
        break;
      case UrlType.NeshanLink:
        this.model.mainUrl = `https://neshan.org/maps/@${lngLat.lat},${lngLat.lng}p/places/SbZnNcGxnKvk`;
        break;
      case UrlType.WazeLink:
        this.model.mainUrl = `https://waze.com/ul?ll=${lngLat.lat},${lngLat.lng}&navigate=yes`;
        break;
    }
  }

  onSubmit() {
    this.onAttachIdToUrl();
    ConsoleService.info('this.model', this.model);

    if (!this.isValidForm(this.form, this.tagName)) return;
    if (this.loading) return;

    if (
      this.model.urlType == UrlType.MapIrLink ||
      this.model.urlType == UrlType.NeshanLink ||
      this.model.urlType == UrlType.WazeLink ||
      this.model.urlType == UrlType.GoogleLink
    )
      this.Map().onSaveButtonClick(null);

    this.checkCreateOrUpdate();
  }
}
